import React, { useState } from "react";
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { useFormik } from "formik";
import * as Yup from "yup";
import { forgotPassword } from "../../services/auth.service";
import { Image } from "react-bootstrap";
import showNotification from "../utils/Notify";
import {Box, Card, Input, Button, Stack} from "@mui/joy";
import fygLupa from "../../assets/FyG-lupa.png";
import AccountBoxIcon from "@mui/icons-material/AccountBox";

type Props = {}

const ForgotPassword: React.FC<Props> = () => {
  let navigate: NavigateFunction = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);

  const initialValues: {
    username: string;
  } = {
    username: "",
  };

  const validationSchema = Yup.object().shape({
    username: Yup.string().required("This field is required!")
  });

  const handleForgotPassword = (formValue: { username: string }) => {
    const { username } = formValue;
    setLoading(true);

    forgotPassword(username)
      .then((response) => {
        showNotification({type: 'success', message: 'An email was sent with the steps to reset the password!'});
        setLoading(false);
        navigate('/login')
      })
      .catch(error => {
        showNotification({type: 'error', message: error.response.data.message});
        setLoading(false);
      });
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    onSubmit: handleForgotPassword,
    validationSchema: validationSchema,
  });

  return (
    <Box
      className="App"
      sx={{
        px: { xs: 2},
        pt: { xs: 'calc(12px + var(--Header-height))' },
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        height: '100dvh',
        overflow: "auto"
      }}
    >
      <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <Card sx={{width: 500}}>
          <Stack direction="row" spacing={1} justifyContent="center" p={0} m={0}>
            <Stack direction="column" spacing={0}>
              <span className="Logo-title"><i>F&G TECHNOLOGIES</i></span>
              <span className="Logo-subtitle"><i><u>Gesti&oacute;n Interna</u></i></span>
            </Stack>
            <Image src={fygLupa} alt="FyG Logo" width={100}/>
          </Stack>
          <label className="Input-label-custom">
            Ingrese su <u>Usuario</u> o <u>Correo Electronico</u> y le enviaremos un email para recuperar su contraseña.
          </label>
          <form className="form" onSubmit={formik.handleSubmit}>
            <Stack spacing={2}>
              <Input
                startDecorator={<AccountBoxIcon/>}
                name="username"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                placeholder="Usuario o Correo Electronico"
                error={!!(formik.touched.username && formik.errors.username)}
                sx={{height: 50}}
              />
              <Button
                type="submit"
                variant="solid"
                className="Button-custom"
                fullWidth
                disabled={loading}
              >
                RECUPERAR CONTRASEÑA
              </Button>
            </Stack>
          </form>
          <div className="text-center">
            <a href="login" className="Forgot-password-link">Back to Login</a>
          </div>
        </Card>
      </Box>
    </Box>
  );
};

export default ForgotPassword;



// Check your email for a link to reset your password. If it doesn’t appear within a few minutes, check your spam folder.


